export { default as DespachosList } from './Listar'
export { default as DespachosCrear } from './Crear';
export { default as DespachoEditar } from './Editar'
export { default as despachoVerBoleta } from './verBoleta'